import React from 'react';
import { string } from 'yup';

import ReferenceDataProvider from '~/utils/reference-data/context';

import PublicResourceUrlField from '~/components/PublicResource/PublicResourceUrlField';

const PublicResources = () => (
  <ReferenceDataProvider
    type="ReferencePublicResource"
    config={{
      customFields: {
        publicResourceUrl: {
          component: PublicResourceUrlField,
          initialValue: '',
          validationSchema: string().url().required(),
        },
      },
    }}
  />
);

export default PublicResources;
